<template>
  <el-table
    show-summary
    :data="data"
    border
    style="width: 100%"
    size="mini"
  >
    <el-table-column
      fixed="left"
      align="center"
      label="序号"
      type="index"
      width="60"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="number"
      label="发车批次号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="itemCategoryName"
      label="费项类型"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="itemServiceName"
      label="费项"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="objectStatus"
      label="结算对象类型"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="objectName"
      label="结算对象"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="amount"
      label="金额"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="paymentMethod	"
      label="付款方式"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="applyReimburseStatus"
      label="是否申请报销"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="dispatchRemarks"
      label="发车备注"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="remarks"
      label="备注"
    ></el-table-column>
    <el-table-column fixed="right" prop="cccc" label="图片">
      <template slot-scope="scope">
        <div
          v-if="scope.row.fileList && scope.row.fileList.length > 0"
          class="lookImgs"
          @click="lookBaseImgs(qiansDatasList.fileList)"
        >
          查看图片
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
    props:{
        data:{
            default(){
                return []
            }
        }
    }
};
</script>

<style>
</style>